import { forwardRef } from "react";
import WheelSvg from "../../assets/wheel.svg?react";

export interface FlywheelSvgProps {
  className?: string;
}

export const FlywheelSvg = forwardRef<SVGSVGElement, FlywheelSvgProps>(
  ({ className }, ref) => {
    return (
      <WheelSvg
        ref={ref}
        className={className}
        style={{
          width: "100%",
          height: "100%",
          //   maxHeight: "50vh",
        }}
      />
    );
  }
);

FlywheelSvg.displayName = "FlywheelSvg";

export default FlywheelSvg;
